/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var MdbIcon = createIcon("MdbIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#BB141A';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.197 30V19.857L10.599 30h1.827l3.429-10.206V30h2.223V16.986h-3.114l-3.447 9.945-3.411-9.945H4.974V30h2.223Zm17.397 0c4.698 0 6.885-2.412 6.885-6.579 0-3.996-1.998-6.327-6.75-6.417-.298-.005-.67-.008-1.06-.01l-.592-.004-.576-.002-1.205-.002h-.068V30h3.366Zm.036-1.809h-1.179v-9.396h1.233c2.808 0 4.5 1.26 4.5 4.635 0 3.492-1.881 4.761-4.554 4.761ZM38.625 30c3.447 0 5.067-1.134 5.067-3.51 0-1.332-.522-2.628-2.637-3.141 1.728-.675 2.322-1.629 2.322-2.961 0-2.196-1.629-3.402-4.932-3.402h-4.473V30h4.653Zm.189-7.47h-2.655v-3.807h2.457c1.548 0 2.646.639 2.646 1.944 0 1.368-1.251 1.863-2.448 1.863Zm-.162 5.724h-2.493v-3.951h2.655c1.503 0 2.655.639 2.655 2.007 0 1.26-.972 1.944-2.817 1.944Z",
    fill: "#fff"
  }));
}, {
  "i18nKey": "svg.MdbIcon",
  "replaceColor": true
});